<section class="upgrade-promotion">
    <div class="container">
        <div class="upgrade-promotion__origin">
            <img alt="img-automovil" class="card__img" [src]="vehicle.img" />
            <h4>{{ vehicle.name }}</h4>
            <p>{{ 'fe_details_upgrade_promotion_info_select' | translate }}</p>
        </div>
        <div class="upgrade-promotion__arrow">
            <img
                [src]="'images/right_arrow_icon.svg' | cdn"
                alt="arrow-light-icon"
                width="24"
                height="24"
            />
        </div>
        <div class="upgrade-promotion__upgrade">
            <div class="upgrade-promotion__upgrade__picture">
                <picture>
                    <img
                        alt="img-automovil"
                        class="card__img"
                        [src]="vehicleUpgradePromotion.img"
                    />
                </picture>
            </div>
            <h4>{{ vehicleUpgradePromotion.name }}</h4>
            <p>({{ vehicleUpgradePromotion.model }})</p>
        </div>
        <div class="upgrade-promotion__info">
            <h4>{{ 'fe_details_upgrade_promotion_title' | translate }}</h4>
            <p>
                {{ 'fe_details_upgrade_promotion_info_1' | translate }}
                {{ vehicle.name }}
                {{ 'fe_details_upgrade_promotion_info_2' | translate }}
                {{ vehicleUpgradePromotion.name }}
                {{ 'fe_details_upgrade_promotion_info_3' | translate }}
                {{ vehicle.name }}.
            </p>
        </div>
    </div>
</section>
